<template>
  <div class="c-modal" v-if="pageVisible">
    <div class="mask">
      <div class="rights-box">
        <Rights v-if="rightType == 'generate'" :rightType="rightType" />
      </div>
      <div class="content">
        <div class="mobile-title">
          <div class="left">{{ $$t("login.sign_in") }}</div>
        </div>
        <div class="close-btn" @click="closePage">
          <img src="@/assets/icons/closeBtn.svg" alt="" />
        </div>
        <div class="flex-center bg-img">
          <div class="login-module-main login-in-main">
            <div class="login-img-box">{{ $$t("login.sign_in") }}</div>
            <div class="login-in-main-content">
              <Login
                @submit="submit"
                @continueWith="continueWith"
                @forgotmodal="forgotmodal"
              />
            </div>
            <p
              v-if="envType !== 'production'"
              class="forget-password-footer tc"
            >
              Don’t have an account?
              <span @click="goSignUp" class="a-link btn pointer">Sign Up</span>
            </p>
            <div class="terms">
              {{ $$t("login.continuing") }}
              <a href="/terms" class="a-link btn pointer">{{
                $$t("login.terms_of_use")
              }}</a>
              {{ $$t("login.and") }}
              <a href="/privacy" class="a-link btn pointer">
                {{ $$t("login.privacy_policy") }}</a
              >
              {{ $$t("login.policy_end") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  onMounted,
  readonly,
  reactive,
  watch,
  triggerRef,
  getCurrentInstance,
} from "vue";
import message from "@/components/functionCallComponent/message/message.js";
import ShowActionDialog from "@/components/functionCallComponent/action/action.js";
import Login from "@/components/login/LoginForm.vue";
import apiUser from "@/api/api/apiUser.js";
import { useRouter } from "vue-router";
import useUserDataStore from "@/store/userDataStore";
import { funComponentList } from "@/components/functionComp/index";
import { getParameterByName, envType } from "@/utils/tools.js";
import Rights from "./rights.vue";
import { getLatestUtmSourceFromCookie } from "@/api/net/config.js";
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js";
import globleConfig from "@/config/config.js";
import { $$language, $$t } from "@/i18n/i18n.js";

//自定义函数组件无法使用全局组件，需要单独引入
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  okText: {
    type: String,
    default: "确定",
  },
  handleOk: {
    type: Function, //成功回调
    default: null,
  },
  handleCancel: {
    type: Function, //失败回调
    default: null,
  },
  remove: {
    type: Function, //传入移除节点方法,这里是createApp中的方法
    default: null,
  },
  content: {
    type: String,
    default: "自定义全局函数组件......",
  },
  rightType: {
    type: String, // 'generate' | 'login' | undefined, // 显示权益的类型
  },
  create_type: {
    type: String,
    default: "2",
  },
  source: {
    type: String,
    default: "other",
  },
});

const pageVisible = ref(false);
pageVisible.value = props.visible;
// 监听显示的消失，需要移除dom
watch(
  () => pageVisible.value,
  (val) => {
    !val && props.remove();
  }
);

const userDataStore = useUserDataStore();
const shopCartStore = useShopCartStore();

const closePage = () => {
  localStorage.removeItem(`${globleConfig.appname}_create_data`);
  pageVisible.value = false;
};

const goSignUp = () => {
  pageVisible.value = false;
  funComponentList.SignUp({
    // content: "在request.ts触发的函数式组件",
    handleOk: props.handleOk,
    handleCancel: props.handleCancel,
    rightType: props.rightType,
  });
};

const forgotmodal = () => {
  pageVisible.value = false;
  localStorage.removeItem(`${globleConfig.appname}_create_data`);
  funComponentList.Forgot({
    rightType: props.rightType,
    handleOk: (str) => {
      console.log("点击成功" + str);
    },
  });
};

// 通用登录响应处理函数
const handleLoginResponse = ({ data, code, msg }, options = {}) => {
  const { successLog, shouldUpdateCart = false } = options;

  if (code === 200) {
    console.log(successLog || "登录成功");
    updateAuthData(data);
    
    // 第三方登录需要更新购物车
    if (shouldUpdateCart) {
      shopCartStore.getCartTotalCount();
    }
    
    // 处理新用户注册
    if (data?.is_new) {
      window?.dataLayer?.push({
        event: "api_register",
      });
      invite();
    }
    
    typeof props.handleOk === "function" && props.handleOk(true);
    pageVisible.value = false;
  } else if (code == 6401) {
    message.error({
      maskClosable: true,
      position: "top",
      content: "Deleted accounts cannot be registered within 14 days.",
    });
  } else {
    typeof props.handleCancel === "function" && props.handleCancel();
    message.error({
      maskClosable: true,
      position: "top",
      content: msg,
    });
  }
};

// 邮箱登录
const submit = async ({ username, email, password }) => {
  console.log("submit", email);
  
  // 记录 Firebase 事件
  firebaseUtils.logClickEvent(
    props.rightType === "generate" ? "newuser_login" : "login",
    {
      create_type: props.create_type,
      page_route: window.location.pathname,
      source: props.source,
    }
  );
  
  // 邮箱登录
  const response = await apiUser.userLogin({
    email: email,
    mode: "email",
    password: password,
    source: getLatestUtmSourceFromCookie() ?? "",
    signup_source: userDataStore.getSignupSource(),
    activity_source: userDataStore.getActivitySource(),
  });
  
  console.log("submit==>", response.data, response.code, response.msg);
  
  // 使用通用处理函数
  handleLoginResponse(response, {
    successLog: "邮箱登录成功",
    shouldUpdateCart: false,
  });
};

// 第三方登录
const continueWith = async (state) => {
  console.log("state", state);
  
  // 第三方登录
  const response = await apiUser.userLogin({
    mode: "google",
    token: state.x_auth_token,
    source: getLatestUtmSourceFromCookie() ?? "",
    signup_source: userDataStore.getSignupSource(),
    activity_source: userDataStore.getActivitySource(),
  });
  
  console.log("data", response.data);
  
  // 使用通用处理函数
  handleLoginResponse(response, {
    successLog: "第三方登录成功",
    shouldUpdateCart: true,
  });
};

const invite = () => {
  const invite = localStorage.getItem("invite_code") ?? "";
  console.log("inviteinvite", invite);
  if (invite) {
    userDataStore.inviteCodePoint(invite);
  }
};

const updateAuthData = (_data) => {
  userDataStore.upDataAuthData(_data.auth);
  userDataStore.updateLoginStatus(true);
};

// onMounted(() => {
//   console.log("tipsDialog onmounted");
// });
</script>

<style lang="scss" scoped>
.c-modal {
  color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  .mask {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 48px;
  }
  .content {
    position: relative;
    left: 0;
    top: 0;
    transform: none;
    overflow: hidden;
    border-radius: 20px;
  }
}
@media screen and (max-width: 768px) {
  .mask {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    .close-btn {
      display: none;
    }
  }
  .content {
    box-sizing: content-box;
    margin: 0;
    width: 300px;
  }
}
</style>
